import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { getRouterLink, ROUTE_PATH } from '@common/types/route-path.enum';
import { StatusEventType } from '@common/types/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StatusCheckerService } from 'src/services/status-checker.service';

@Component({
	selector: 'app-current-status-events',
	templateUrl: './current-status-events.component.html',
	styleUrls: ['./current-status-events.component.scss'],
})
export class CurrentStatusEventsComponent {
	displayCurrentStatus$: Observable<boolean>;

	ROUTE_PATH = ROUTE_PATH;

	getRouterLink = getRouterLink;

	constructor(
		private statusCheckerService: StatusCheckerService,
		private router: Router
	) {
		this.displayCurrentStatus$ =
			this.statusCheckerService.currentStatusEvents$.pipe(
				map((statusEvents) => {
					if (statusEvents?.length > 0 && this.router.url === '/') {
						return statusEvents.filter(
							(s) => s.type === StatusEventType.incident
						).length > 0
							? true
							: false;
					}
					return false;
				})
			);
	}
}
